import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { QuoteStatus } from '../../../../../models/status/status.model'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-edited-quote-dialog',
  templateUrl: './edited-quote-dialog.component.html',
  styleUrls: ['./edited-quote-dialog.component.scss'],
})
export class EditedQuoteDialogComponent implements OnInit {
  operation
  status = QuoteStatus
  constructor(private launchDialogService: LaunchDialogService) {}
  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.operation = data.operation
    })
  }

  closeModal(message): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.EDITED_QUOTE,
      reason: message,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
